module.exports = __webpack_public_path__ + "static/checkmark-for-verification-99cb8c0b573a709e353934cbd19c62e8.png";